import { useSelector } from 'react-redux';

import { Author } from '../../../components/Author';
import { getQuestionById } from '../../../selectors/questions';

interface IAuthorContainerProps {
  questionId: string;
}

export function AuthorContainer({ questionId }: IAuthorContainerProps) {
  const { user, date } = useSelector(getQuestionById(questionId));

  return <Author name={user.name} avatarUrl={user.avatarUrl} date={date} />;
}
